import angular from 'angular';

import { StripeStates }                from './stripe.states.ajs';
import { StripeSettingsCtrl }          from './stripe.settings.ajs';

angular.module('workshop.stripe', [])
  .config(StripeStates)
  .controller('StripeSettingsCtrl', StripeSettingsCtrl);
